import { createResetStateMutation } from '@/helpers';
import { getInitialStateAuth } from './state';

export const loginUser = (state, { access_token, usuario }) => {
   state.access_token = access_token;
   state.usuario = usuario;
};

export const removeToken = () => {
   sessionStorage.removeItem('access_token');
};

export const resetState = createResetStateMutation(getInitialStateAuth);
